import { render, staticRenderFns } from "./ctrlurl.vue?vue&type=template&id=16033e94"
import script from "./ctrlurl.vue?vue&type=script&lang=js"
export * from "./ctrlurl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports